export default __webpack_public_path__ + "static/media/micIcon.41de326f.svg";